import React, { useState } from 'react';
import './Footer.scss';

const Footer = () => {
  const [modalContent, setModalContent] = useState(null);

  const openModal = (type) => {
    setModalContent(type);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setModalContent(null);
    document.body.style.overflow = 'unset';
  };

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-top">
          <div className="f-logo">BEST TRADING</div>
          <ul className="f-menu">
            <li>
              <button type="button" onClick={() => openModal('terms')}>
                이용약관
              </button>
            </li>
            <li>
              <button type="button" onClick={() => openModal('privacy')} className="privacy">
                개인정보처리방침
              </button>
            </li>
          </ul>
        </div>

        <div className="footer-bottom">
          <div className="info">
            <div className="company-info">
              <p>
                <span>상호명 : (주)베스트트레이딩</span>
                <span className="bar">|</span>
                <span>대표자 : 오장덕</span>
                <span className="bar">|</span>
                <span>사업자등록번호 : 124-86-22361</span>
              </p>
              <p>
                <span>주소 : 경기도 화성시 정남면 서봉로 921번길 76-48</span>
              </p>
              <p>
                <span>TEL : 031-366-0666</span>
                <span className="bar">|</span>
                <span>FAX : 0504-035-1485</span>
                <span className="bar">|</span>
                <span>E-MAIL : oy7112@gmail.com</span>
              </p>
            </div>
            <p className="copy">Copyright © 2026 BEST TRADING. All Rights Reserved.</p>
          </div>
        </div>
      </div>

      {/* 모달 시스템 */}
      {modalContent && (
        <div className="f-modal-overlay" onClick={closeModal}>
          <div className="f-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>{modalContent === 'terms' ? '서비스 이용약관' : '개인정보처리방침'}</h3>
              <button className="close-btn" onClick={closeModal}>
                &times;
              </button>
            </div>
            <div className="modal-body">{modalContent === 'terms' ? <TermsContent /> : <PrivacyContent />}</div>
          </div>
        </div>
      )}
    </footer>
  );
};

// --- 법적으로 탄탄한 이용약관 내용 ---
const TermsContent = () => (
  <div className="policy-text">
    <h4>제1조 (목적)</h4>
    <p>
      본 약관은 (주)베스트트레이딩(이하 "회사")이 운영하는 공식 웹사이트(이하 "사이트")에서 제공하는 샘플 신청, 견적
      문의 등 관련 서비스(이하 "서비스")를 이용함에 있어 회사와 이용자의 권리, 의무 및 책임사항을 규정함을 목적으로
      합니다.
    </p>

    <h4>제2조 (이용계약의 성립)</h4>
    <p>
      이용자가 사이트 내 제공된 양식에 정보를 입력하고 "신청하기" 또는 "문의하기" 버튼을 누름과 동시에 본 약관 및
      개인정보처리방침에 동의한 것으로 간주하며 서비스 이용 신청이 성립됩니다.
    </p>

    <h4>제3조 (서비스의 제공 및 변경)</h4>
    <p>
      1. 회사는 이용자에게 테이프 제품 정보 제공, 샘플 무상/유상 지원, 맞춤형 견적 산출 서비스를 제공합니다.
      <br />
      2. 회사는 기술적 사양의 변경이나 제조 공정의 사정에 따라 서비스의 내용을 변경할 수 있습니다.
    </p>

    <h4>제4조 (이용자의 의무)</h4>
    <p>
      이용자는 다음 행위를 하여서는 안 됩니다.
      <br />
      1. 신청 시 허위 내용의 등록 (타인 명의 도용 등)
      <br />
      2. 사이트에 게시된 정보의 무단 변경 또는 상업적 활용
      <br />
      3. 회사 및 제3자의 저작권 등 지적재산권에 대한 침해
    </p>

    <h4>제5조 (면책조항)</h4>
    <p>
      1. 회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 책임이
      면제됩니다.
      <br />
      2. 이용자가 기재한 부정확한 연락처, 주소 정보로 인해 발생하는 배송 오류 및 연락 두절에 대해 회사는 책임을 지지
      않습니다.
    </p>
  </div>
);

// --- 개인정보보호법 기준 필수 기재 사항 포함 ---
const PrivacyContent = () => (
  <div className="policy-text">
    <p className="highlight">
      <strong>(주)베스트트레이딩은 귀하의 개인정보를 중요시하며, '개인정보보호법'을 준수하고 있습니다.</strong>
    </p>

    <h4>1. 수집하는 개인정보 항목 및 수집방법</h4>
    <p>회사는 샘플 신청 및 견적 문의 응대를 위해 아래와 같은 개인정보를 수집하고 있습니다.</p>
    <ul>
      <li>
        <strong>수집항목:</strong> 회사명, 담당자 성명, 연락처(전화번호/휴대폰), 이메일 주소, 배송지 주소, 제품 사용용도
      </li>
      <li>
        <strong>수집방법:</strong> 웹사이트 내 폼 메일 입력을 통한 직접 수집
      </li>
    </ul>

    <h4>2. 개인정보의 수집 및 이용목적</h4>
    <p>
      수집된 개인정보는 다음의 목적 이외의 용도로는 사용되지 않으며 이용 목적이 변경될 시에는 사전 동의를 구할
      예정입니다.
    </p>
    <ul>
      <li>샘플 발송 및 배송 상태 확인</li>
      <li>견적 상담 및 제품 단가 안내</li>
      <li>신제품 안내 및 기술 자료 제공 (동의 시)</li>
    </ul>

    <h4>3. 개인정보의 보유 및 이용기간</h4>
    <p>
      원칙적으로, 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다. 단, 관계법령의 규정에
      의하여 보존할 필요가 있는 경우 아래와 같이 보유합니다.
    </p>
    <ul>
      <li>
        <strong>보존 항목:</strong> 상담 내역, 서비스 이용 기록
      </li>
      <li>
        <strong>보존 근거:</strong> 소비자의 불만 또는 분쟁처리에 관한 기록 (전자상거래법)
      </li>
      <li>
        <strong>보존 기간:</strong> 3년
      </li>
    </ul>

    <h4>4. 개인정보의 파기절차 및 방법</h4>
    <p>전자적 파일형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.</p>

    <h4>5. 이용자의 권리</h4>
    <p>
      이용자는 언제든지 등록되어 있는 자신의 개인정보를 조회하거나 수정을 요청할 수 있으며, 회사의 개인정보
      관리책임자에게 서면, 전화 또는 이메일로 연락하시면 지체 없이 조치하겠습니다.
    </p>

    <h4>6. 개인정보 보호책임자</h4>
    <p>고객의 개인정보를 보호하고 관련 불만을 처리하기 위하여 아래와 같이 책임자를 지정하고 있습니다.</p>
    <ul>
      <li>책임자: 오영진</li>
      <li>문의처: oy7112@gmail.com / 031-366-0666</li>
    </ul>
  </div>
);

export default Footer;
